import type { CartItem } from "@/lib/cartStorage";
import type { PublicProduct } from "@/types/models";

export function publicProductToCartItem(product: PublicProduct): CartItem {
  return {
    productId: product.id,
    name: product.name,
    slug: product.slug,
    priceCents: product.priceCents,
    quantity: 1,
    thumbnailUrl: product.images[0]?.thumbnailUrl ?? null,
  };
}

/** Keep persisted cart order; drop IDs the API did not return (inactive, deleted, wrong store). */
export function mergeValidatedCartItems(
  pending: CartItem[],
  products: PublicProduct[]
): CartItem[] {
  const byId = new Map(products.map((p) => [p.id, publicProductToCartItem(p)]));
  return pending
    .map((item) => {
      const fresh = byId.get(item.productId);
      if (!fresh) return null;
      return { ...fresh, quantity: item.quantity ?? 1 };
    })
    .filter((item): item is CartItem => item != null);
}
